import { Maybe } from '@lichtblick/types';

export const downloadFile = (resultUrl: string, fileType: string, fileName?: Maybe<string>, onEvent?: () => void) => {
  const link = document.createElement('a');
  const currentFileName = fileName ?? `file.${fileType}`;

  link.href = resultUrl;
  link.download = currentFileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(resultUrl);
  onEvent?.();
};
